import isEmpty from 'lodash/isEmpty';
import { normalize } from 'normalizr';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { SCHEMA_INIT } from './types';
import { buildQueryParams } from '../../lib/utils';

import { treksSchema } from '../Schema';
import { getCustomToast } from '../../components/ErrorMessage';
import { setLoadingState } from './filterTreksActions';

export const storeTreksByIds = (trek, type) => {
  const { entities } = normalize(trek ? trek : {}, treksSchema);
  const data = entities.treks ? entities.treks : {};
  return {
    type: SCHEMA_INIT,
    payload: { schema: type, data },
  };
};

const getEndpointWithOrWithoutQueryParams = state => {
  const { withOutRegion: endpoint } = endpoints.treks.all;
  const queryParams = state.trekFiltersType.query;

  return isEmpty(queryParams) ? endpoint : buildQueryParams(endpoint, queryParams, true);
};

export const fetchMyTreks = () => async dispatch => {
  try {
    const { data } = await api.getWithToken(endpoints.treks.my);
    dispatch(storeTreksByIds(data, 'myTreks'));
  } catch (err) {
    getCustomToast('There was some error trying to fetch treks.', 'error');
  }
};

export const fetchAllTreks = () => async (dispatch, getState) => {
  try {
    dispatch(setLoadingState(true));
    const { data } = await api.get(getEndpointWithOrWithoutQueryParams(getState()));
    dispatch(storeTreksByIds(data, 'treks'));
  } catch (err) {
    getCustomToast('There was some error trying to fetch treks.', 'error');
  } finally {
    dispatch(setLoadingState(false));
  }
};



// WEBPACK FOOTER //
// ./src/redux/actions/trekActions.js